import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';
import { Iconify } from '@pflegenavi/web-components';

export const LinkedTableSection: FC<
  PropsWithChildren<{
    title: string;
    /** Shown in parentheses after the title. */
    count?: number;
    /** Shown in a tooltip on an info icon next to the title. */
    hint?: string;
    testId?: string;
  }>
> = ({ title, count, hint, testId, children }) => (
  <Stack sx={{ gap: 2 }} data-testid={testId}>
    <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5 }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
        {count === undefined ? title : `${title} (${count})`}
      </Typography>
      {hint && (
        <Tooltip arrow title={hint}>
          <Iconify
            icon="eva:info-outline"
            width={18}
            sx={{ color: 'text.secondary' }}
          />
        </Tooltip>
      )}
    </Stack>
    {children}
  </Stack>
);
